module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cohort-i-mentors.json
// module id = 667
// module chunks = 177669786165816